module.exports = __webpack_public_path__ + "static/img/ercRuleLib.c4403147.png";